/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";
import { SRLWrapper } from "simple-react-lightbox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useTranslation } from "react-i18next";
import ProductCarousel from "./ProductCarousel";
import ProductTitleVideo from "./ProductTitleVideo";
import ProductShare from "./ProductShare";
import ProductDesc from "./ProductDesc";
import SimilarProductsDynamic from "../common/SimilarProductsDynamic";

function BulasikDeterjaniLuks() {
const [activeIndex, setActiveIndex] = useState(0);

const handleSelect = (selectedIndex) => {
setActiveIndex(selectedIndex);
};

const handlePrev = () => {
handleSelect(activeIndex === 0 ? 5 : activeIndex - 1);
};

const handleNext = () => {
handleSelect(activeIndex === 5 ? 0 : activeIndex + 1);
};

const { t } = useTranslation();

const [expanded, setExpanded] = useState(false);

const toggleNav = () => {
setExpanded(!expanded);
};

const handleClick = () => {
window.scrollTo(0, 0);
setExpanded(false);
};

const customProducts = [
  {
    "picture": "assets/images/20-kg/6.webp",
    "nav": "/bulasikmakina",
    "title": "B. Makina Deterjanı"
  },
  {
    "picture": "assets/images/20-kg/7.webp",
    "nav": "/bulasikmakinaparlaticisi",
    "title": "B. Makina Parlatıcısı"
  },
  {
    "picture": "assets/images/20-kg/9.webp",
    "nav": "/bulasikdeterjaniekstra",
    "title": "B. Deterjanı Ekstra"
  },
  {
    "picture": "assets/images/20-kg/13.webp",
    "nav": "/bulasikmakinapro",
    "title": "B. Makina Deterjanı Pro"
  },
  {
    "picture": "assets/images/20-kg/14.webp",
    "nav": "/bulasikmakinaparlaticisipro",
    "title": "B. Makina Parlatıcısı Pro"
  }
]

return (
<>
  <SRLWrapper>
    <section class="product-details section-space">
      <div class="container">
        <div class="row gutter-y-50">
          <div class="col-lg-6 col-xl-6 wow fadeInLeft" data-wow-delay="200ms">
            <div class="product-details__img">
              <div class="swiper product-details__gallery-top p-5">
                <div className="album-list-item">
                  <Link className="ali-link" onClick={handleClick} as={Link} to="/Armur">
                  <div className="ali-img-wrap">
                    <div>
                      <img className="img-fluid blur-up lazyload" src="assets/images/20-kg/5.webp" alt="image" title="image" />
                    </div>
                  </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-6 wow fadeInRight" data-wow-delay="300ms">
            <div class="product-details__content">
              <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <ProductTitleVideo title="Bulaşık Deterjanı Lüks" video="" />
                <span className="product-details__weight"
                  style={{fontSize: '16px', fontWeight: 'bold', color: '#10adad'}}>
                  5 KG - 20 KG
                </span>
              </div>
              <div class="product-details__excerpt">
                <h4 class="mt-4 mb-3">ÖZELLİKLERİ</h4>
              <ul class="product-details__list">
                <li>Elde bulaşık yıkamak için özel formüle edilmiştir.</li>
                <li>Donmuş yağı ve yanık artıklarını, inatçı kirleri bile (nişasta, protein gibi) kolayca çıkarır.</li>
                <li>Hoş kokuludur, bol köpüklüdür, kolay durulanır, leke bırakmaz.</li>
                <li>Mamul içinde aktif maddeler en az %60 oranında doğada parçalanabilir.</li>
                <li>Anyonik aktif madde %5-15, nonyonik aktif madde %1-5, koruyucu, parfüm ve boya içerir.</li>
              </ul>

              <h4 class="mt-4 mb-3">KULLANIM ŞEKLİ VE MİKTARI</h4>
              <ul class="product-details__list">
                <li>Her litre suya 1 gr veya 2 gr "Dexpur Elde Bulaşık Yıkama Maddesi" ilave ediniz.</li>
                <li>Çok ağır kirler için bu miktarı arttırabilirsiniz.</li>
                <li>Bu dozajlar, testlere ve denemelere göre tavsiye edilmektedir.</li>
              </ul>
              </div>

              <div class="product-details__buttons">
                <Link as={Link} to="/urunlerimiz" class="product-details__btn boskery-btn">
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__hover"></span>
                <span class="boskery-btn__text">
                  {" "}
                  DİĞER ÜRÜNLERİMİZ
                </span>
                <i class="icon-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-details__description-wrapper">
        <div class="container">
          <div class="product-details__description">
            <h3 class="product-details__description__title">
              Ürün Detayları
            </h3>
            <div class="product-details__text__box wow fadeInUp" data-wow-delay="300ms">

              <h4 class="mt-4 mb-3">ÜRÜN BİLEŞİMİ</h4>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-dark">
                    <tr>
                      <th>MADDE ADI</th>
                      <th>DERİŞİM</th>
                      <th>CAS No.*</th>
                      <th>EC No.*</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Deiyonize Su</td>
                      <td>% 85 - %90</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>Linear Alkil Benzen Sülfonik Asit</td>
                      <td>&lt; % 5</td>
                      <td>85536-14-7</td>
                      <td>287-494-3</td>
                    </tr>
                    <tr>
                      <td>Sodyum Laureth Sulfat</td>
                      <td>&lt; % 5</td>
                      <td>68891-38-3</td>
                      <td>500-234-8</td>
                    </tr>
                    <tr>
                      <td>Kokoamidopropil Betain</td>
                      <td>&lt; % 5</td>
                      <td>61789-40-0</td>
                      <td>263-058-8</td>
                    </tr>
                    <tr>
                      <td>Ürea</td>
                      <td>&lt; % 5</td>
                      <td>57-13-6</td>
                      <td>200-315-5</td>
                    </tr>
                    <tr>
                      <td>5-chloro-2-methyl-4-isothiazolin-3-one<br/>2-methyl-4-isothiazolin-3-one</td>
                      <td>&lt; % 5</td>
                      <td>26172-55-4<br/>2682-20-4</td>
                      <td>247-500-7<br/>220-239-6</td>
                    </tr>
                    <tr>
                      <td>Sodyum Hidroksit</td>
                      <td>&lt; % 5</td>
                      <td>1310-73-2</td>
                      <td>215-185-5</td>
                    </tr>
                    <tr>
                      <td>Cocoamide Dea</td>
                      <td>&lt; % 5</td>
                      <td>68603-42-9</td>
                      <td>271-657-0</td>
                    </tr>
                    <tr>
                      <td>Sodyum Klorür</td>
                      <td>&lt; % 5</td>
                      <td>68603-42-9</td>
                      <td>231-598-3</td>
                    </tr>
                    <tr>
                      <td>Esans, boya</td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="alert alert-info mt-4 p-4 text-white" style={{ backgroundColor: "#10adad" }}>
                <h6><strong>TÜKETİCİNİN DİKKATİNE :</strong></h6>
                <ul class="mb-0">
                  <li>Uzun süreli temaslarda cildin korunması için lastik eldiven kullanılması tavsiye edilir.</li>
                  <li>Göz kaçağı takdirde, bol suyla yıkayıp kurulanınız.</li>
                  <li>Kullandıktan sonra ellerinizi bol suyla yıkayıp kurulanınız.</li>
                  <li>Gıda maddelerinden uzak tutunuz.</li>
                  <li>Cilt korumak için elden ile uzun süreli temasta kaçınınız.</li>
                  <li>El, yüz, vücut ve gıda temizliğinde kullanmayınız.</li>
                  <li>Çocuklardan uzak tutunuz.</li>
                  <li>Kapakta bulunan emniyet pimi kırılmış bidonları satın almayınız.</li>
                  <li>Çocuklardan uzak tutunuz.</li>
                  <li>Dexpur, yanlış kullanım ve saklamadan doğacak zarardan sorumlu değildir.</li>
                </ul>
              </div>

              <div class="danger-warnings mt-4 p-3 bg-danger text-white">
                <h6><strong>⚠️ ZEHİRLENME DURUMUNDA:</strong></h6>
                <div class="alert alert-light mt-3 mb-3 text-dark">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="mb-1"><strong>114'ü</strong></p>
                      <p class="mb-0 small">ULUSAL ZEHİR DANIŞMA MERKEZİ</p>
                    </div>
                    <div class="col-md-6">
                      <p class="mb-1"><strong>112'yi</strong></p>
                      <p class="mb-0 small">ACİL SAĞLIK HİZMETLERİ</p>
                    </div>
                  </div>
                </div>
                
                <div class="alert alert-warning mt-3 mb-0">
                  <p class="mb-0">
                    <strong>⚠️ DİKKAT :</strong> Üretim tarihi, son kullanma tarihi ile parti no ve seri no, ambalajın üzerindedir.
                  </p>
                </div>
              </div>

              <div class="product-info-box mt-4 p-3 bg-light">
                <h6><strong>📋 TEKNİK BİLGİLER:</strong></h6>
                <div class="row">
                    <p><strong>Net Ağırlık:</strong> 5 KG ve 20 KG Seçenekleri mevcuttur.</p>
                    <p><strong>Üretici Firma :</strong> Seymen Kimya Temizlik San. ve Tic. Ltd. Şti.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  </SRLWrapper>

    <SimilarProductsDynamic products={customProducts} handleClick={handleClick} />
</>
);
}

export default BulasikDeterjaniLuks;